import { Routes } from '@angular/router';

import { advicesRoutes } from './advices/advices.routes';
import { bemAdviceRoutes } from './bem/advice/bem-advice.routes';
import { blightRoutes } from './blight-v2/blight.routes';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { downyMildewRoutes } from './downy-mildew/downy-mildew.routes';
import { powerBiDashboardsRoutes } from './power-bi-dashboards/power-bi-dashboards.routes';
import { tgaRoutes } from './tga/tga.routes';
import { virusMonitorRoutes } from './virus-monitor/virus-monitor.routes';

export const appRoutes: Routes = [
  ...dashboardRoutes,
  ...advicesRoutes,
  ...powerBiDashboardsRoutes,
  ...blightRoutes,
  ...downyMildewRoutes,
  ...tgaRoutes,
  ...virusMonitorRoutes,
  ...bemAdviceRoutes,
];
